import dayjs from 'dayjs';
import { ICustomerOrder } from 'app/shared/model/customer-order.model';
import { ContractType } from 'app/shared/model/enumerations/contract-type.model';
import { AgreementStatus } from 'app/shared/model/enumerations/agreement-status.model';

export interface IAgreement {
  id?: number;
  effectiveDate?: dayjs.Dayjs | null;
  expirationDate?: dayjs.Dayjs | null;
  endDate?: dayjs.Dayjs | null;
  contractType?: keyof typeof ContractType | null;
  createdTimestamp?: dayjs.Dayjs | null;
  status?: keyof typeof AgreementStatus | null;
  customerOrder?: ICustomerOrder | null;
}

export const defaultValue: Readonly<IAgreement> = {};
